import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { TopLevelScore } from 'ff/debrief/models';
import CircularScore from 'ff/debrief/components/segments/CircularScore';

interface Props {
    scores: TopLevelScore[];
}

const TopLevelScores: React.FC<Props> = props => (
    <Box mx={1}>
        <Grid container spacing="1px">
            {props.scores
                ? props.scores.map(s => (
                      <ScoreGrid size={6} key={s.categoryLabel}>
                          <CircularScore
                              score={s.score}
                              label={s.categoryLabel}
                              sx={{ bgcolor: 'white' }}
                          />
                      </ScoreGrid>
                  ))
                : [1, 2, 3, 4].map(n => (
                      <ScoreGrid size={6} key={n}>
                          <CircularScore sx={{ bgcolor: 'white' }} />
                      </ScoreGrid>
                  ))}
            {props.scores?.length % 2 === 1 && (
                <ScoreGrid size={6}>
                    <Box height={48} bgcolor="#FFFFFF" />
                </ScoreGrid>
            )}
        </Grid>
    </Box>
);

const ScoreGrid = styled(Grid)`
    background-color: transparent;
`;

export default TopLevelScores;
